import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {  get, handleResponse, swal500 } from '../../utils/network';
import AuditLogsComponent from './AuditLogsComponent';
import { buildUrlQueryString } from '../../utils/utils';

const AuditLogsContainer = ({ entityProps, messages, columns, mock, prefetchAllPages = false, searchEnabled = false, filterEnabled = false, searchFilter, filter, enableDuplicate = false, allowCreateNew = true, enableActions = true }) => {
  const history = useHistory();
  const location = useLocation();

  const { entityName, endpoint, path } = entityProps;
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [maxPageFetched, setMaxPageFetched] = useState(0);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [searchWord, setSearchWord] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [filters, setFilters] = useState({
    page: 0,
    showSessionLogs: false
  });

  const applyFilters = () => getData(filters);

  const getData = (filters) => {
    setLoading(true)
    const url = buildUrlQueryString(endpoint, { ...filters, page: filters.page + 1 })

    get(url)
      .then(res => handleResponse(res, { history }))
      .then(parsed => {
        setData(parsed.message.data);
        setCount(parsed.message.totalAuditLogs);
        setMaxPageFetched(0);
      })
      .catch(err => swal500(err))
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getData(filters);

    const msgKey = location.state?.msg;
    if (msgKey) {
      const msg = messages[msgKey];
      msg && setSuccessMessage(msg);
    }
  }, [location.state, messages, mock, prefetchAllPages, searchEnabled, filterEnabled]);

  const handleChangePage = (event, newPage) => {
    const newFilters = { ...filters, page: newPage };
    setFilters(newFilters);
    getData(newFilters)
    window.scrollTo(0, 0);
  };

  const onCloseToast = () => setSuccessMessage('');

  return (
    <AuditLogsComponent
      page={filters.page}
      loading={loading}
      data={!searchEnabled ? data : filteredData}
      dataCount={!searchEnabled ? count : filteredData.length}
      path={path}
      title={messages.title}
      columns={columns}
      handleChangePage={handleChangePage}
      filters={filters}
      setFilters={setFilters}
      applyFilters={applyFilters}
      onCloseToast={onCloseToast}
      successMessage={successMessage}
      loadingMore={loadingMore}
      enableDuplicate={enableDuplicate}
    />
  );
};

export default AuditLogsContainer;